import { Link } from 'react-router-dom';
import { softwareList } from '@/mocks/software';
import { formatDownloads } from '@/utils/catalog';

const rankColor = ['bg-accent-500 text-foreground-950', 'bg-secondary-400 text-foreground-950', 'bg-secondary-300 text-foreground-800'];

export default function TopRanking() {
  const ranking = [...softwareList].sort((a, b) => b.downloads - a.downloads).slice(0, 5);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-bar-chart-fill text-lg"></i>
        </span>
        <h2 className="text-base font-bold text-foreground-950">热门下载排行榜</h2>
      </div>

      <ul className="flex flex-col">
        {ranking.map((item, i) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.id}`}
              className="group flex items-center gap-3 rounded-md px-2 py-3 transition-colors hover:bg-background-100"
            >
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                  rankColor[i] ?? 'bg-background-200 text-foreground-600'
                }`}
              >
                {i + 1}
              </span>
              <span className="flex h-11 w-11 shrink-0 overflow-hidden rounded-md bg-secondary-100">
                <img src={item.cover} alt={item.name} title={`${item.name} - 看片软件`} className="h-full w-full object-cover object-top" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-foreground-900 group-hover:text-primary-600">
                  {item.name}
                </span>
                <span className="mt-0.5 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-download-2-line"></i>
                  {formatDownloads(item.downloads)}次下载
                </span>
              </span>
              <i className="ri-arrow-right-s-line text-lg text-foreground-300 group-hover:text-primary-500"></i>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}